import * as actionTypes from '../constants/saveForLaterConstants';
const initialState = {
    loading: false,
    savedItems: [],
    error: null,
  };
  
  export const saveForLaterReducer = (state = initialState, action) => {
    switch (action.type) {
      case actionTypes.CART_MOVE_TO_SAVEFORLATER_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case actionTypes.CART_MOVE_TO_SAVEFORLATER_SUCCESS:
        return {
          ...state,
          loading: false,
          savedItems: action.payload,
        };
      case actionTypes.CART_MOVE_TO_SAVEFORLATER_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case actionTypes.CART_MOVE_TO_CART_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case actionTypes.CART_MOVE_TO_CART_SUCCESS:
        return {
          ...state,
          loading: false,
          savedItems: action.payload,
        };
      case actionTypes.CART_MOVE_TO_CART_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      case actionTypes.GET_SAVE_FOR_LATER_ITEMS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case actionTypes.GET_SAVE_FOR_LATER_ITEMS_SUCCESS:
        return {
          ...state,
          loading: false,
          savedItems: action.payload,
        };
      case actionTypes.GET_SAVE_FOR_LATER_ITEMS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };